import { z } from 'zod';

import { BorrowerId } from '../../BrandedIds';
import { StopSettings } from '../../loan/StopSettings';
import { WorkoutPlanInput } from '../../loan/WorkoutPlan';
import { zodBrandedUuid } from '../../utils';
import { BaseLoanEvent } from '../BaseLoanEvent';

export const CreateWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('createWorkoutPlan'),
  data: WorkoutPlanInput,
  flags: StopSettings.pick({ portalPayments: true, drawsPaused: true }).optional(),
  borrowerIds: z.array(zodBrandedUuid<BorrowerId>()),
});
export type CreateWorkoutPlanEvent = z.infer<typeof CreateWorkoutPlanEvent>;
